import { Box, VStack } from '@chakra-ui/react'
import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import Table from '../../components/Table/Table'
import UnderlineHeading from '../../components/UnderlineText/UnderlineHeading'
import { REPOSITORY } from './../../api/repository/Repository'
import { useNavigate } from 'react-router-dom'

const columns = [
  {
    Header: 'Acciones',
    type: 'clickeable',
    accessor: 'seeInfo',
    keyValue: 'idContacto',
  },
  {
    Header: 'Tipo de contacto',
    accessor: 'sTipoContacto',
  },
  {
    Header: 'Nombre',
    accessor: 'sNombreContacto',
  },
  {
    Header: 'Cargo',
    accessor: 'sCargo',
  },
  {
    Header: 'Teléfono fijo',
    accessor: 'sTelefonoFijo',
  },
  {
    Header: 'Celular',
    accessor: 'sTelefonoMovil',
  },
  {
    Header: 'Correo electrónico',
    accessor: 'sEmailContacto',
  },
]

const logColumns = [
  {
    Header: 'Fecha',
    accessor: 'dFechaLog',
  },
  {
    Header: 'Usuario',
    accessor: 'sUsuario',
  },
  {
    Header: 'Contacto',
    accessor: 'sNombreContacto',
  },
  {
    Header: 'Campo modificado',
    accessor: 'sCampo',
  },
  {
    Header: 'Valor anterior',
    accessor: 'sValorAnterior',
  },
  {
    Header: 'Valor nuevo',
    accessor: 'sValorNuevo',
  },
]

const fieldLabels = {
  sTipoContacto: 'Tipo de contacto',
  sCargo: 'Cargo',
  sNombre: 'Nombre',
  sApellidoPaterno: 'Apellido paterno',
  sApellidoMaterno: 'Apellido materno',
  sRut: 'RUT',
  sTelefono: 'Teléfono fijo',
  sTelefonoMovil: 'Celular',
  sEmail: 'Correo electrónico',
  sDireccion: 'Dirección',
  sComuna: 'Comuna',
  sRegion: 'Región',
  sObservacion: 'Observación',
  sCentroCostoCliente: 'Centro de costo',
  sSucursalCliente: 'Sucursal',
}

const buildLogRows = (entries) => {
  if (!Array.isArray(entries)) return []
  return entries.flatMap((entry) => {
    const { dLogDate, sUsuario, before, after } = entry
    if (!before || !after) return []
    const nombreContacto = `${after.sNombre ?? ''} ${
      after.sApellidoPaterno ?? ''
    } ${after.sApellidoMaterno ?? ''}`.trim()
    const keys = new Set([...Object.keys(before), ...Object.keys(after)])
    return Array.from(keys)
      .filter((key) => before[key] !== after[key])
      .map((key) => ({
        dFechaLog: dLogDate,
        sUsuario: sUsuario ?? '—',
        sNombreContacto: nombreContacto,
        sCampo: fieldLabels[key] ?? key,
        sValorAnterior: before[key] ?? '—',
        sValorNuevo: after[key] ?? '—',
      }))
  })
}

export default function Contacts() {
  const [data, setData] = useState([])
  const [logData, setLogData] = useState([])
  const navigate = useNavigate()

  const handleFetch = async () => {
    await REPOSITORY.wsEmpresa.employees.getContacts().then((res) => {
      setData(res.data)
    })
  }

  const handleFetchLog = async () => {
    await REPOSITORY.wsEmpresa.employees.getListaLogContactos().then((res) => {
      setLogData(buildLogRows(res.data))
    })
  }

  const onCLick = (value) => {
    navigate(`${value}`)
  }

  useEffect(() => {
    handleFetch()
    handleFetchLog()
  }, [])

  return (
    <VStack mb="100px" spacing="31px" alignItems="flex-start" w="100%">
      <UnderlineHeading text={'Datos de interlocutores'} variant="h5" />
      <Box p="25px" w="100%" boxShadow="-9px 14px 44px rgba(0, 0, 0, 0.15)">
        <Table onEmployeeClick={onCLick} columns={columns} data={data} />
      </Box>
      <UnderlineHeading text={'Historial de cambios'} variant="h5" />
      <Box p="25px" w="100%" boxShadow="-9px 14px 44px rgba(0, 0, 0, 0.15)">
        <Table columns={logColumns} data={logData} />
      </Box>
    </VStack>
  )
}
